const doisDigitos = (valor: number) => String(valor).padStart(2, "0");

const formatarData = (data: Date) =>
  `${doisDigitos(data.getUTCDate())}/${doisDigitos(data.getUTCMonth() + 1)}/${data.getUTCFullYear()}`;

export const textoJanelaPrevisoes = (fim: string): string => {
  if (!fim) {
    return "";
  }
  const [ano, mes, dia] = fim.split("-").map(Number);
  const vendasAte = new Date(Date.UTC(ano, mes - 1, dia));
  const recebimentoDesde = new Date(Date.UTC(ano, mes - 1, dia + 1));
  return `Vendas realizadas até ${formatarData(vendasAte)}, com recebimento previsto a partir de ${formatarData(
    recebimentoDesde
  )}.`;
};
